import { Alert, Box, Snackbar } from '@mui/material';
import axios from 'axios';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const MODIFICATION_CODE = 269;
const INPROGRESS_STATE_SAVED = 270;
const SURVEY_ACTIVE = 271;
const CREATION_CODE = 201;
const DELETION_CODE = 204;

interface SuccessSnackbarState {
  readonly open: boolean;
  readonly successMessage: string;
}

const SUCCESS_MESSAGE_RECORD: Record<number, string> = {
  [MODIFICATION_CODE]: 'GENERAL_USER_ACTION_SUCCESS_HANDLER.MODIFICATION_SUCCESS',
  [INPROGRESS_STATE_SAVED]: 'GENERAL_USER_ACTION_SUCCESS_HANDLER.INPROGRESS_STATE_SAVED',
  [SURVEY_ACTIVE]: 'GENERAL_USER_ACTION_SUCCESS_HANDLER.SURVEY_ACTIVE',
  [CREATION_CODE]: 'GENERAL_USER_ACTION_SUCCESS_HANDLER.ADD_NEW_SUCCESS',
  [DELETION_CODE]: 'GENERAL_USER_ACTION_SUCCESS_HANDLER.DELETE_SUCCESS',
};

const responseStatusCodes: number[] = [CREATION_CODE, DELETION_CODE, MODIFICATION_CODE, INPROGRESS_STATE_SAVED, SURVEY_ACTIVE];

const GeneralUserActionSuccessHandler: React.FC = () => {
  const { t } = useTranslation();
  const [snackbarState, setSnackbarState] = useState<SuccessSnackbarState>({ open: false, successMessage: '' });

  axios.interceptors.response.use((response) => {
    if (responseStatusCodes.includes(response.status)) {
      setSnackbarState({
        open: true,
        successMessage: t(SUCCESS_MESSAGE_RECORD[response.status]),
      });
    }
    return response;
  });

  const handleClose = () => {
    setSnackbarState({ open: false, successMessage: '' });
  };

  return (
    <Box sx={{ width: 1000 }}>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{ marginTop: '60px' }}
        open={snackbarState.open}
        onClose={handleClose}
        autoHideDuration={5000}
      >
        <Alert severity="success" sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
          {snackbarState.successMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default GeneralUserActionSuccessHandler;
